// demo-webscm 2026 11 02 / ODOO-350612 (навигатор интерфейса): предикаты шага «спробую сам» (действие тура wait_for, бэк guide.TOUR_CHECK_KINDS).
// Чистые функции над стором и документом — без сети; guidePlay опрашивает guideChecks_eval, пока не true или не вышел таймаут.
// snap — снимок guideChecks_begin в момент старта шага (для «что-то случилось ПОСЛЕ старта»: alt_tip, question_sent).
const str = (v) => (v === undefined || v === null) ? '' : String(v)
const isObj = (x) => !!(x && typeof x === 'object')

export const GUIDE_CHECK_KINDS = ['workspace', 'page', 'widget_open', 'tab', 'chip_added', 'popout', 'alt_tip', 'dom', 'question_sent']

function activeWs(store) { return str(store?.activeWORKSPACE?.workspace) }
function activePage(store) { return str(store?.activeWORKSPACE?.active_page) }
function wsWidgets(store, ws) { const W = store?.WORKSPACES?.[ws || activeWs(store)]; return Array.isArray(W?.ALL_WIDGETS) ? W.ALL_WIDGETS : [] }
function pickWidgets(store, check) {
    const all = wsWidgets(store, check.workspace)
    const page = check.page ? str(check.page) : activePage(store)
    return all.filter(w => w && (!page || str(w.page) === page) && (!check.widget || str(w.widget) === str(check.widget) || str(w.id) === str(check.widget)))
}
function chipRows(store, check) {
    const W = store?.WORKSPACES?.[check.workspace || activeWs(store)]
    const WHERE = W?.record?.doc?.params?.WHERE
    return Array.isArray(WHERE) ? WHERE : []
}
function chipHasValue(row) {
    const rv = row?.rightValue
    if (isObj(rv) ? str(rv.value) : str(rv)) return true
    return Array.isArray(row?.attrs) && row.attrs.some(a => isObj(a?.rightValue) ? str(a.rightValue.value) : str(a?.rightValue))
}
function tabName(tab) { return isObj(tab) ? str(tab.name || tab.html_id || tab.title) : str(tab) }
function widgetTab(W, want) {
    const vs = isObj(W?.attrs_vueObj) ? Object.values(W.attrs_vueObj) : []
    for (const v of vs) {
        const tp = v?.tabPanel
        if (!tp) continue
        const tabs = tp.tabs || tp.localTabs || []
        const idx = Number(tp.selectedIndex)
        const names = [tabName(tabs[idx]), str(tp.localSelected), str(tp.selectedTab?.name)]
        if (names.some(n => n && n.toLowerCase() === want.toLowerCase())) return true
    }
    return false
}

// demo-webscm 2026 11 02 / ODOO-350612 (скан -102: тема «Відкрити віджет із меню сторінки» без подсветки — её wait_for widget_open без widget был истинным
// с первого опроса: на странице «Баланс» виджеты уже открыты; док тут же снимал подсказки и отмечал тему): проверки «пользователь что-то СДЕЛАЛ» сравниваются
// со снимком на старте шага. widget_open — открыт виджет, которого не было открыто, или активирован подходящий другой (выбор уже открытого в меню страницы
// активирует его); popout — откреплён виджет, который не был откреплён; chip_added — появился чипс со значением, которого не было. Без снимка (старый вызов
// guideChecks_eval без begin) — прежнее поведение
const isOpen = (w) => !!w && !w.close && !w._softClosed
const wKey = (w) => str(w?.id) + '|' + str(w?.widget)
const chipKey = (r) => { try { return JSON.stringify([r?.leftValue, r?.rightValue, r?.attrs || null, r?.use, r?.hidden]) } catch (e) { return '' } }
function chipMatch(r, check) {
    const b = str(check.binding)
    return isObj(r) && r.use !== false && r.hidden !== true && (!b || str(isObj(r.leftValue) ? r.leftValue.value : r.leftValue) === b) && (check.any || chipHasValue(r))
}
// снимок до старта шага
export function guideChecks_begin(store, check) {
    const k = str(check?.kind)
    if (k === 'alt_tip') return { altTipEpoch: Number(store?.altTipEpoch) || 0 }
    if (k === 'question_sent') return { asked: Number(store?.navigator?.asked) || 0 }
    if (k === 'widget_open') return { open: pickWidgets(store, check).filter(isOpen).map(wKey), active: store?.activeWIDGET || null }
    if (k === 'popout') return { popout: pickWidgets(store, check).filter(w => isOpen(w) && str(w.styleWidget?.dock) === 'popout').map(wKey) }
    if (k === 'chip_added') return { chips: chipRows(store, check).filter(r => chipMatch(r, check)).map(chipKey) }
    return {}
}

// true — условие шага выполнено
export function guideChecks_eval(store, check, snap = {}, doc = globalThis.document) {
    if (!isObj(check)) return false
    const k = str(check.kind)
    try {
        switch (k) {
        case 'workspace':
            return !!check.workspace && activeWs(store) === str(check.workspace)
        case 'page':
            return !!check.page && activePage(store) === str(check.page) && (!check.workspace || activeWs(store) === str(check.workspace))
        case 'widget_open': {
            const ws = pickWidgets(store, check)
            if (!Array.isArray(snap?.open)) return ws.length > 0
            const act = store?.activeWIDGET
            return ws.some(w => isOpen(w) && (!snap.open.includes(wKey(w)) || (w === act && act !== snap.active)))
        }
        case 'popout': {
            const ws = pickWidgets(store, check).filter(w => str(w.styleWidget?.dock) === 'popout')
            if (!Array.isArray(snap?.popout)) return ws.length > 0
            return ws.some(w => isOpen(w) && !snap.popout.includes(wKey(w)))
        }
        case 'tab': {
            const want = str(check.tab || check.value)
            if (!want) return false
            return pickWidgets(store, check).some(w => widgetTab(w, want))
        }
        case 'chip_added': {
            if (Array.isArray(snap?.chips)) return chipRows(store, check).some(r => chipMatch(r, check) && !snap.chips.includes(chipKey(r)))
            const b = str(check.binding)
            return chipRows(store, check).some(r => isObj(r) && r.use !== false && r.hidden !== true && (!b || str(isObj(r.leftValue) ? r.leftValue.value : r.leftValue) === b) && (check.any || chipHasValue(r)))   // без binding — любой пользовательский чипс со значением
        }
        case 'alt_tip':
            return (Number(store?.altTipEpoch) || 0) > (Number(snap?.altTipEpoch) || 0)
        case 'question_sent':
            return (Number(store?.navigator?.asked) || 0) > (Number(snap?.asked) || 0)
        case 'dom': {
            const sel = str(check.value)
            if (!sel || !doc?.querySelector) return false
            const el = doc.querySelector(sel)
            return !!el && (check.any || el.offsetWidth > 0 || el.offsetHeight > 0 || !('offsetWidth' in el))
        }
        default:
            return false
        }
    } catch (e) { return false }
}
